declare global {
	interface Window {
		ONVIO_VERTICAL_VERSION?: string;
	}
}

export const environment = {
	production: true,
	verticalName: 'StaffApplication',
	// The reference to window.ONVIO_VERTICAL_VERSION will be replaced with an script with the real version on build time
	version: window.ONVIO_VERTICAL_VERSION ?? '0.0.0.0',
};
